export { default as ContactAboutSectionWithFragment } from './contact-about-section-with-fragment';
export { default as ContactAboutSectionWithQuery } from './contact-about-section-with-query';

export { default as AgencyAboutSectionWithFragment } from './agency-about-section-with-fragment';
export { default as AgencyAboutSectionWithQuery } from './agency-about-section-with-query';
